import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Typography,
  Box,
  useMediaQuery,
  useTheme
} from '@mui/material';

const GolfScoreTable = ({ scores, team = true }) => {
  //console.log("GolfScoreTable", scores);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  scores?.forEach((score) => {
    // Calculate total from all roundX keys
    const rounds = Object.keys(score).filter(key => key.startsWith('round'));
  
    const totalScore = rounds.reduce((total, round) => {
      const roundScore = parseFloat(score[round]);
      return total + (isNaN(roundScore) ? 0 : roundScore);
    }, 0);
  
    score.total = totalScore;
  
    // Format display from `score.score`, not from total
    score.display = score.score === undefined
      ? (score.status ?? '-')
      :  score.score === 0
        ? 'E'
        : score.score > 0
          ? `+${score.score}`
          : `${score.score}`;
  });
  //console.log("Formatted Scores", scores);
  
  
  return (
    <TableContainer 
      component={Paper} 
      elevation={0} 
      sx={{ 
        maxWidth: '750px', 
        overflowX: 'auto', 
        borderRadius: 0,
        margin: '0 auto',
      }}
    >
      <Box>
        <Table 
          size="small" 
          aria-label="player scores table"
          sx={{ 
            minWidth: isSmallScreen ? '450px' : '600px', // Reduced minimum width on small screens
          }}
        >
          <TableHead>
            <TableRow sx={{ 
              backgroundColor: '#002129',
              '& th': { 
                borderRight: 'none',
                borderBottom: 'none',
                color: 'white',
                fontWeight: 'bold',
                padding: isSmallScreen ? '8px 12px' : '12px 16px', // Reduced padding on small screens
                whiteSpace: 'nowrap'
              }
            }}>
              <TableCell sx={{ 
                width: '40px', 
                fontSize: '14px',
                padding: isSmallScreen ? '8px 4px' : '12px 16px', // Smaller padding for rank on small screens
              }}>
                RANK
              </TableCell>  
              <TableCell 
                sx={{ 
                  width: isSmallScreen ? '45vw' : '45vw', // Smaller on mobile devices
                  maxWidth: isSmallScreen ? '45vw' : '45vw',
                  fontSize: '14px'
                }}
              >
                EVENT
              </TableCell>

              <TableCell align="center" sx={{ 
                minWidth: isSmallScreen ? '45px' : '60px', 
                fontSize: '14px',
                padding: isSmallScreen ? '8px 4px' : '12px 16px',
              }}>
                {team ? 'TOTAL' : 'TO PAR'}
              </TableCell>
              
              <TableCell align="center" sx={{ 
                minWidth: isSmallScreen ? '40px' : '60px', 
                fontSize: '14px',
                padding: isSmallScreen ? '8px 4px' : '12px 16px',
              }}
              >
                R1
              </TableCell>

              <TableCell align="center" sx={{ 
                minWidth: isSmallScreen ? '40px' : '60px', 
                fontSize: '14px',
                padding: isSmallScreen ? '8px 4px' : '12px 16px',
              }}
              >
                R2
              </TableCell>

              <TableCell align="center" sx={{ 
                minWidth: isSmallScreen ? '40px' : '60px', 
                fontSize: '14px',
                padding: isSmallScreen ? '8px 4px' : '12px 16px',
              }}>
                TOT
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scores?.map((row, index) => (
              <TableRow
                key={row.eventName}
                sx={{ 
                  '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                  '&:nth-of-type(even)': { backgroundColor: 'white' },
                  '& td': { 
                    borderBottom: 'none',
                    padding: isSmallScreen ? '12px 4px' : '16px', // Reduced padding on small screens
                    whiteSpace: 'nowrap',
                    fontSize: '12px',
                    padding: '12px 0px',
                  }
                }}
              >
                <TableCell sx={{ padding: isSmallScreen ? '12px 4px' : '16px' }}>
                  <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#000',
                        textAlign: 'center',
                    }}
                  >
                    {row.rank || `-`}
                  </Typography>
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    width: isSmallScreen ? '35vw' : '35vw', // Smaller on mobile
                    maxWidth: isSmallScreen ? '35vw' : '35vw',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    borderBottom: 'none !important',
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                        fontSize: '12px !important',
                        fontWeight: 500,
                        color: '#000',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        borderBottom: 'none !important',
                    }}
                  >
                    {row.eventName}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ padding: isSmallScreen ? '12px 4px' : '16px' }}>
                  <Typography sx={{ fontWeight: 'medium', fontSize: '14px' }}>
                    {row.display}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ 
                  fontSize: '14px !important',
                  padding: isSmallScreen ? '12px 4px' : '16px'
                }}>{row.round1}</TableCell>
                <TableCell align="center" sx={{ 
                  fontSize: '14px !important',
                  padding: isSmallScreen ? '12px 4px' : '16px'
                }}>{row.round2 || '-'}</TableCell>
                <TableCell align="center" sx={{ 
                  fontSize: '14px !important',
                  padding: isSmallScreen ? '12px 4px' : '16px'
                }}>{row.total === 0 ? '-' : row.total}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default GolfScoreTable;